export default __webpack_public_path__ + "167442ccd229c69c12525cb41278d8df.png";